<template>
  <div class="pa-10">
    <h1 class="mb-4">Dashboard</h1>
    <div class="d-flex flex-wrap" style="gap: 25px" v-if="stats.length > 1">
      <v-card
        style="
          position: relative;
          border: 1px solid hsl(214.3 31.8% 91.4%);
          border-radius: 0.5rem;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          display: grid;
        "
        flat
        class="bg-smokeDark"
        width="400"
        v-for="([key], i) in Object.entries(stats[0]).filter(
          ([key]) => key !== 'timestamp',
        )"
        :key="i"
      >
        <div class="pa-4">
          <div class="ps-4 text-caption text-medium-emphasis">{{ key }}</div>

          <v-card-title
            class="pt-0 mt-n1 d-flex align-center justify-space-between"
          >
            <div class="d-flex align-center">
              <div class="me-2">{{ stats[stats.length - 1][key] }}</div>

              <v-chip
                :color="color"
                :prepend-icon="`mdi-arrow-${stats[stats.length - 1][key] - stats[stats.length - 2][key] < 0 ? 'down' : 'up'}`"
                class="pe-1"
                size="x-small"
                label
              >
                <template v-slot:prepend>
                  <v-icon size="10"></v-icon>
                </template>

                <span class="text-caption">{{
                  stats[stats.length - 1][key] - stats[stats.length - 2][key]
                }}</span>
              </v-chip>
            </div>
          </v-card-title>
        </div>

        <v-sparkline
          color="accent"
          :model-value="stats.map((item) => item[key])"
          height="50"
          line-width="1"
          min="0"
          padding="0"
          fill
          smooth
        ></v-sparkline>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      stats: (state) => state.admin.stats,
    }),
  },
};
</script>
